import bodybuilder from 'bodybuilder'
import fromPairs from 'lodash/fp/fromPairs'
import map from 'lodash/fp/map'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import propOr from 'lodash/fp/propOr'
import * as Request from '../request'
import * as Constants from './constants'
import * as Types from './types'

export const selectAggs = propOr({}, 'aggregations')
export const selectBuckets = propOr([], 'buckets')
export const selectCounts = propOr(0, 'doc_count')
export const selectKey = propOr('', 'key')
export const selectValue = prop('value')

export const findTerm = (fieldName: string) => (buckets: Types.Bucket[] = []) =>
  buckets.find(({key}) => key === fieldName)

interface Args {bucket: Types.Bucket[], timestamp: string}
export const findTimeBucket = ({bucket = [], timestamp}: Args) =>
  bucket.find(({key_as_string}) => key_as_string === timestamp)
export const selectValueAgg = (aggName: string) => pipe(
  prop(aggName),
  selectValue,
)
export const selectAggBuckets = (aggName: string) => pipe(
  prop(aggName),
  selectBuckets,
)
export const createAggSelector = (aggName: string) => pipe(
  selectAggs,
  selectAggBuckets(aggName),
)
export const selectUniqueCount: any = propOr(0, `${Constants.AggFieldNames.UniqueCount}.value`)
export const selectDocCount = propOr<Types.Bucket, 'doc_count', number>(0, 'doc_count')
export const createCountMap = map(
  pipe(
    over<any>([selectKey, selectCounts]),
    fromPairs,
  ),
)
export const keyword = (field: string): string => `${field}.keyword`
export const buildAggBody = () => bodybuilder().size(0)
export const asPercentage = (n: number = 0) => n === 0 ? '0' : (n * 100).toFixed(2)
export const createEsSearch = (constant: string) => (community: string, index: string, payload: {}) =>
Request.requestActionCreator(constant)({
  method: 'POST',
  payload,
  url: `/es/${community}/${index}`,
})

interface Args {
  community: string,
  start?: string,
  end?: string,
}
type CreateReportBody = (args: Args) => bodybuilder.Bodybuilder
export const createReportBody: CreateReportBody = ({community, start = 'now-1M/w', end = 'now/w'}) =>
  bodybuilder()
    .size(0)
    .filter(
      'term',
      keyword(Constants.DocumentFieldNames.Community),
      community,
    ).query(
      'range',
      Constants.DocumentFieldNames.MessageSendDate,
      { gte: start, lt: end },
    )



// WEBPACK FOOTER //
// ./src/elasticsearch/utils.ts